import { useEffect } from 'react';
import PrivacyHeroSection from '../components/PrivacyPolicy/PrivacyHeroSection';
import PrivacyContent from '../components/PrivacyPolicy/PrivacyContent';
import Silk from '../components/SilkBackground';

function PrivacyPolicy() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (

    <>
    {/* Silk background */}
      <div className="fixed inset-0 -z-10 pointer-events-none">
        <Silk
          speed={10}
          scale={1}
          color="#e3c8b3"
          noiseIntensity={1.5}
          rotation={0}
        />
      </div>

      <div className="min-h-screen bg-[#f2d6c0]/80 backdrop-blur-md">
        <PrivacyHeroSection />
        <main className="container mx-auto px-4 py-12">
          <div className="max-w-6xl mx-auto">
          <PrivacyContent />
        </div>
      </main>
    </div>
    </>
    
    
  );
}

export default PrivacyPolicy;
  